import { memo } from 'react'
import { Icon } from '@winnin/ds-icon'
import { ContextMenu } from '@winnin/winnin_ui.components.context-menu'

import { ThreeDotsVerticalIcon } from 'assets/icons/three-dots-vertical'
import { FileStorageStatus } from 'generated/graphql'
import { withTolgee } from 'lib/tolgee'
import { FileUploadStatus } from 'modules/documents/common/contexts'

import { translations } from './upload-list-item.i18n'
import type { TUploadListItemViewProps } from './upload-list-item.types'

import './upload-list-item.styles.scss'

const Component = withTolgee<TUploadListItemViewProps>(
  ({ fileType, fileExtension, formattedFileSize, formattedDateTime, handleDelete, children, disabled, t, status }) => (
    <div className="UploadListItem" data-isNotProcessed={status !== FileStorageStatus.Processed}>
      <div className="UploadListItem-column" style={{ minWidth: '20px' }}>
        <Icon
          name={fileType}
          color={`var(--color_neutral_${status !== FileStorageStatus.Processed ? '500' : '0'})`}
          width={20}
          height={20}
        />
      </div>

      <div className="UploadListItem-column" style={{ width: '100%' }}>
        <span className="UploadListItem-filename">{children}</span>
      </div>

      <div className="UploadListItem-column right" style={{ minWidth: '40px' }}>
        <span className="UploadListItem-extension">{fileExtension?.toUpperCase().replace('.', '')}</span>
      </div>

      <div className="UploadListItem-column" style={{ minWidth: '50px' }}>
        <span className="UploadListItem-size">{formattedFileSize}</span>
      </div>

      <div className="UploadListItem-column right" style={{ minWidth: '145px' }}>
        <span className="UploadListItem-date">{formattedDateTime}</span>
      </div>

      <div className="UploadListItem-column right" style={{ minWidth: '85px' }}>
        <span className="UploadListItem-status">
          {status === FileStorageStatus.Processed
            ? t(translations.fileStatusProcessed)
            : status === FileUploadStatus.Uploading
              ? t(translations.fileStatusUploading)
              : t(translations.fileStatusProcessing)}
        </span>
      </div>

      <div className="UploadListItem-column right" style={{ minWidth: '20px' }} data-disabled={disabled}>
        <ContextMenu
          menuItems={[
            {
              label: t(translations.dropdownActionRemove),
              onClick: handleDelete,
              isDisabled: disabled,
            },
          ]}
        >
          <ThreeDotsVerticalIcon color={`var(--color_neutral_${disabled ? '500' : '0'})`} width={20} height={20} />
        </ContextMenu>
      </div>
    </div>
  )
)

export const UploadListItemView = memo(Component)
